import { QuestionType } from '../../../interface/multiCapabilityTemplate';
import { IQuestionElementProps } from '../interface';
import { CheckboxQuestion } from './checkboxQuestion';
import { NumberQuestion } from './numberQuestion';
import { RadioQuestion } from './radioQuestion';
import { TextQuestion } from './textQuestion';
import { QuestionOperateConfig } from './questionOperateConfig';
import { lang } from '@umu/ukit-lang';
interface IQuestionMapInfo {
    label: string;
    components?: (props: IQuestionElementProps) => JSX.Element;
}
const questionMap: Record<QuestionType, IQuestionMapInfo> = {
    [QuestionType.RADIO]: {
        label: lang('单选题'),
        components: RadioQuestion,
    },
    [QuestionType.CHECKBOX3]: {
        label: lang('多选题'),
        components: CheckboxQuestion,
    },
    [QuestionType.TEXT]: {
        label: lang('开放式'),
        components: TextQuestion,
    },
    [QuestionType.NUMBER5]: {
        label: lang('数值型'),
        components: NumberQuestion,
    },
    [QuestionType.PARAGRAPH]: {
        label: lang('段落说明：'),
    },
};
export { questionMap, QuestionOperateConfig };
